import { BackendError } from './BackendError';

// The backend has provided information indicating that the node server is
// running but Civi is not available, so it can't do much.
export class CiviCrmUncontactableError extends BackendError {
  static errorName = 'CiviCrmUncontactableError';
}
